<template>
  <b-modal
    :id="id"
    title="¿Eliminar?"
    centered
    modal-class="avify-confirmation-modal"
    :hide-header-close="true"
    size="xs"
  >
    ¿Seguro que quieres eliminar el elemento?
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="xl"
          class="float-right"
          @click="$emit('onCancelRemoveConfirmation')"
        >
          No, gracias
        </b-button>
        <b-button
          variant="secondary"
          size="xl"
          class="float-left"
          @click="$emit('onConfirmRemoveConfirmation')"
        >
          Eliminar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'RemoveConfirmationModal',
  props: {
    id: {
      type: String
    }
  }
}
</script>

<style lang="less">
  .avify-confirmation-modal {

    .modal-xs {
      @media (min-width: 576px) {
        max-width: 400px;
      }
    }

    .modal-content {
      background-color: #31395A;
      border-bottom: none;
    }

    .modal-header {
      border-bottom: none;
      justify-content: center;
    }

    .modal-title {
      color: white;
      font-size: 14px;
      @media (min-width: 576px) {
        font-size: 20px;
      }
    }

    .modal-body {
      text-align: center;
      color: white;
    }

    .modal-footer {
      border-top: none;
    }

  }
</style>
